import React, { useState, useEffect, useRef } from 'react';
import './ComingSoon.css';

const TAGLINE = 'Exclusive Single Origin Coffee';
const SUBTITLE = 'Sourced from the World\'s Finest Origins';

function useTypewriter(text, speed = 60, startDelay = 1200) {
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    let timeout;
    let i = 0;

    timeout = setTimeout(() => {
      const interval = setInterval(() => {
        i += 1;
        setDisplayed(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(interval);
          setDone(true);
        }
      }, speed);
      return () => clearInterval(interval);
    }, startDelay);

    return () => clearTimeout(timeout);
  }, [text, speed, startDelay]);

  return { displayed, done };
}

export default function ComingSoon() {
  const [emailValue, setEmailValue] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const { displayed: typedTagline, done: taglineDone } = useTypewriter(TAGLINE, 45, 800);
  const inputRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = emailValue.trim();
    if (!email) return;

    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.status === 200 || res.status === 201) {
        setSubmitted(true);
      } else if (res.status === 429) {
        setError('Too many requests. Please try again later.');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch {
      setError('Unable to connect. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cs-page">
      <div className="cs-grain" />

      <main className={`cs-main ${visible ? 'cs-main--visible' : ''}`}>
        <div className="cs-logo-wrap">
          <img
            src="/logo.png"
            alt="Satu Origin Coffee"
            className="cs-logo"
          />
        </div>

        <div className="cs-divider">
          <span className="cs-divider__star">✦</span>
        </div>

        <div className="cs-headline">
          <h1 className="cs-coming-soon">
            <span className="cs-coming-soon__text">Coming Soon</span>
            <span className="cs-coming-soon__dots" aria-hidden="true">
              <span>.</span><span>.</span><span>.</span>
            </span>
          </h1>
        </div>

        <p className="cs-tagline">
          <span className="cs-tagline__typed">{typedTagline}</span>
          {taglineDone && <span className="cs-tagline__cursor" />}
        </p>

        <p className="cs-subtitle">{SUBTITLE}</p>

        <div className="cs-notify">
          {!submitted ? (
            <>
              <p className="cs-notify__label">Be the first to know when we launch</p>
              <form className="cs-form" onSubmit={handleSubmit}>
                <input
                  ref={inputRef}
                  type="email"
                  className="cs-form__input"
                  placeholder="your@email.com"
                  value={emailValue}
                  onChange={(e) => { setEmailValue(e.target.value); setError(''); }}
                  aria-label="Email address"
                  required
                  disabled={loading}
                />
                <button type="submit" className="cs-form__btn" disabled={loading}>
                  {loading ? '...' : 'Notify Me'}
                </button>
              </form>
              {error && <p className="cs-form__error">{error}</p>}
            </>
          ) : (
            <div className="cs-success">
              <span className="cs-success__icon">✦</span>
              <p className="cs-success__msg">Thank you — we'll be in touch.</p>
            </div>
          )}
        </div>
      </main>

      <footer className="cs-footer">
        <p>&copy; 2026 Satu Origin Coffee. All rights reserved.</p>
      </footer>
    </div>
  );
}
